import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './ChangePassword.css';
import Input from '../../../../components/Input/Input';
import Button from '../../../../components/Button/Button';
import eyeOff from '../../../../assets/login/eyeOff.png';
import eyeOn from '../../../../assets/login/eyeOn.png';
import Modal from '../../../../components/Modal/Modal';
import profileDefault from '../../../../assets/profileDefault.png';
// services
import { usersList } from '../../../../services/user';
import { authService } from '../../../../services/login';

const ChangePassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userData = location.state?.user;
  const profilePhoto = location.state?.profile_photo;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [title, setTitle] = useState({ text: '', highlight: '' });
  const [message, setMessage] = useState('');
  const [errorResponse, setErrorResponse] = useState(false);
  console.log('User data:', userData);

  const [formData, setFormData] = useState({
    current_password: '',
    new_password: '',
    confirmation: ''
  });

  const handleChange = (e, field) => {
    setFormData(prev => ({
      ...prev,
      [field]: e.target.value
    }));
  };

  const handleCancel = () => {
    navigate(-1);
  };

  // Función para validar el formato de la contraseña
  // Validaciones de contraseña
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    // Validate required fields
    if (!formData.current_password?.trim()) {
      newErrors.current_password = 'Current password is required';
    }

    if (!formData.new_password?.trim()) {
      newErrors.new_password = 'New password is required';
    }

    // Validate that new password is different from current
    if (formData.current_password && formData.new_password && 
        formData.current_password === formData.new_password) {
      newErrors.new_password = 'New password cannot be the same as current password';
    }

    if(formData.new_password.length < 8 || formData.new_password.length > 16) {
      newErrors.new_password = 'New password must be between 8 and 16 characters long';
    }

    // Validate that passwords match
    if (formData.new_password && formData.confirmation && 
        formData.new_password !== formData.confirmation) {
      newErrors.confirmation = 'Passwords do not match';
    }

    // Validate password format
    if (formData.new_password) {
      const hasUpperCase = /[A-Z]/.test(formData.new_password);
      const hasLowerCase = /[a-z]/.test(formData.new_password);
      const hasNumber = /[0-9]/.test(formData.new_password);

      if (!hasUpperCase || !hasLowerCase || !hasNumber) {
        newErrors.new_password = 'Password must contain at least one uppercase letter, one lowercase letter, and one number';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    try {
      if (!validateForm()) {
        return;
      }

      const response = await usersList.changePassword(formData);
      console.log('Contraseña actualizada exitosamente:', response);

      if (response.status === 'success') {
        setTitle({ text: 'Successful', highlight: 'change' });
        setMessage('For security reasons you must log in again');
        setErrorResponse(false);
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error('Error changing password:', error.response?.data?.message);
      setTitle({ text: 'Error changing', highlight: 'password' });
      setMessage(error.response?.data?.message || 'Error changing password');
      setErrorResponse(true);
      setIsModalOpen(true);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    if(errorResponse) return;
    // Cerrar sesión
    authService.logout();
    // Redirigir al login
    navigate('/');
  };

  return (
    <div className="change-password-page">

      <div className="profile-card">
        <div className="profile-banner">
          <div className="profile-photo-container">
            <img 
              src={profilePhoto || profileDefault} 
              alt={userData?.user || 'Profile photo'} 
              className="profile-photo"
            />
          </div>
        </div>

        <div className="profile-info">
          <h2 className="profile-name">{userData.name || 'Usuario'}</h2>
          <p className="profile-role">{userData?.role || 'Role'}</p>

          <div className="password-form">
            <div className="form-group">
              <label>Current password</label>
              <Input
                type="password"
                placeholder="Enter your current password"
                value={formData.current_password}
                onChange={(e) => handleChange(e, 'current_password')}
                required
                icon={eyeOff}
                iconAlt={eyeOn}
                error={errors.current_password}
              />
            </div>

            <div className="form-group">
              <label>New password</label>
              <Input
                type="password"
                placeholder="Enter your new password"
                value={formData.new_password}
                onChange={(e) => handleChange(e, 'new_password')}
                required
                icon={eyeOff}
                iconAlt={eyeOn}
                error={errors.new_password}
              />
            </div>

            <div className="form-group">
              <label>Confirm password</label>
              <Input
                type="password"
                placeholder="Confirm password"
                value={formData.confirmation}
                onChange={(e) => handleChange(e, 'confirmation')}
                required
                icon={eyeOff}
                iconAlt={eyeOn}
                error={errors.confirmation}
              />
            </div>
          </div>

          <div className="form-actions">
            <Button 
              onClick={handleCancel}
              type="button"
              fullWidth
            >
              Cancel
            </Button>
            <Button 
              onClick={handleSave}
              type="submit"
              fullWidth
            >
              Save
            </Button>
          </div>
          <Modal 
            isOpen={isModalOpen}
            onClose={handleModalClose}
            title={title}
            message={message}
            onConfirm={handleModalClose}
            error={errorResponse}
          />
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;